import { getField, updateField } from 'vuex-map-fields';
import apiAxios from '../../services/apiAxios';
import helpers from '../../mixins/helpers';

const state = {
    id: 0,
    nombre: '',
    color: '#ff0000', /* Rojo */
    finalizado: false,
    inactivo: false,
    rowVersion: null,
    
    briefTareaEstadoDatos: [],
};

const mutations = {
    updateField,

    'INICIALIZAR'(state, briefTareaEstadoId) {
        state.id = briefTareaEstadoId;
        state.nombre = '';
        state.color = '#ff0000';
        state.finalizado = false;
        state.inactivo = false;
        state.rowVersion = null;
    },
    'SET_BRIEF_TAREA_ESTADO'(state, briefTareaEstado) {
        state.nombre = briefTareaEstado.nombre.toUpperCase().trim();
        state.color = briefTareaEstado.color;
        state.finalizado = (/true/i).test(briefTareaEstado.finalizado);
        state.inactivo = (/true/i).test(briefTareaEstado.inactivo);
        state.rowVersion = briefTareaEstado.rowVersion;
    },

    'INICIALIZAR_DATOS'(state) {
        state.briefTareaEstadoDatos = [];
    },
    'SET_DATOS'(state, briefTareaEstadoDatos) {
        state.briefTareaEstadoDatos = briefTareaEstadoDatos;
    },
};

const getters = {
    getField,
};

const actions = {
    inicializar ( { commit }, briefTareaEstadoId ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR', briefTareaEstadoId);
            
            if (briefTareaEstadoId == 0){
                reject(new Error('La opción de registrar nuevos estados se encuentra deshabilitada'))
            }

            if (briefTareaEstadoId != 0){
                apiAxios.get(`briefs/tareas/estados/${briefTareaEstadoId}/abm` ) 
                    .then(res => {
                        commit('SET_BRIEF_TAREA_ESTADO', res.data);
                        resolve();
                    })
                    .catch(error => reject(helpers.methods.getErrorMessage(error)));
            } else {
                resolve();
            }
        })
    },    
    save ( {commit} ) {
        return new Promise((resolve, reject) => {
            let briefTareaEstado= {
                nombre: state.nombre.toUpperCase().trim(),
                color: state.color.trim(),
                finalizado: (/true/i).test(state.finalizado),
                inactivo: (/true/i).test(state.inactivo),
            }
            
            let url = 'briefs/tareas/estados';

            if (state.id != 0) {
                url += '/' + state.id;
                briefTareaEstado.rowVersion = state.rowVersion
            }

            apiAxios.post(url, briefTareaEstado)
                .then((res) => {
                    // /* Actualizamos Id y RowVersion */
                    // commit('SET_BRIEF_TAREA_ESTADO', res.data);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },

    getDatos ( { commit }, briefTareaEstadoId ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_DATOS');

            if (briefTareaEstadoId != 0) {
                apiAxios.get(`briefs/tareas/estados/${briefTareaEstadoId}`) 
                    .then(res => {
                        let datos = [
                            { 'nombre': 'id', 'campo': 'Cod.', 'valor': res.data.id, 'formato': '' },
                            { 'nombre': 'nombre', 'campo': 'Nombre', 'valor': res.data.nombre, 'formato': '' },
                            { 'nombre': 'finalizado', 'campo': 'Finalizado', 'valor': res.data.finalizado? 'Si' : 'No', 'formato': '' },
                            { 'nombre': 'inactivo', 'campo': 'Inactivo', 'valor': res.data.inactivo? 'Si' : 'No', 'formato': '' },
                        ];
                        
                        commit('SET_DATOS', datos);
                        resolve();
                    })
                    .catch(error => reject(helpers.methods.getErrorMessage(error)));
            } else {
                resolve();
            }
        })            
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}